<div *ngFor="let toast of toasts$ | async; let i = index">
  <i2g-toast
    [id]="toast.id"
    [message]="toast.message"
    [timeout]="toast.timeout"
    [position]="i"
  >
  </i2g-toast>
</div>
